<template>
  <sButton
    data-qa="btn-tender-complete"
    :disabled="disabled"
    :loading="loading"
    @click="completeTender">
    {{ $t(`Tenders.Complete`) }}
  </sButton>
</template>

<script>
import { tenderMixin } from 'mixins'

import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

export default {
  name: 'tenderFinished',
  mixins: [tenderMixin],
  data() {
    return {
      loading: false
    }
  },
  props: {
    tender: Object,
    disabled: Boolean,
    text: String,
    /**
     * Отправлять ли участникам причину
     */
    addToSupplierNotification: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function
    },
    close: {
      type: Function
    },
  },
  computed: {
    // is_prequalification() {
    //   return this.tender?.tenderStatus?.id == 5
    // },
    winners() {
      return this.tender?.bids?.filter(bid => bid.bidDetails?.some(el => el.selectedBid))
        .map(item => item.bidderInfo.organizationName )
    }
  },
  methods: {
    async completeTender() {
      const validate = new Promise((resolve) => {
        if (!this.validate) {
          resolve(true)
        } else {
          resolve(this.validate())
        }
      })

      validate.then(async (validateResult) => {
        if (validateResult) {
          let is_prequalification = this.tender?.tenderStatus?.id == 5
          this.loading = true

          await tender_api.tenderFinish(this.tender.tenderId, this.text, this.addToSupplierNotification)
            .then( async (result) => {
              await this.$_updateStatus(this.tender)
              await this.$_updateTenderAccess(this.tender)
              if ( this.close ) {
                this.close()
              }
              if (!result) {
                return
              }

              let info = {
                title: `${this.$t('Tenders.Tender')} #${this.tender.tenderNumber}  ${this.$t('Tenders.Completed')}`,
                closable: true,
                okText: this.$t('Common.Close') ,
                cancelText: this.$t('Common.Close'),
                onOk: () => {
                  this.$router.push({name: 'tenderitem',
                    params: { id: this.tender?.tenderId, org: this.$route.params.org},
                    query: {tab: 'offers'}})
                },
                onCancel: () => {
                  this.$router.push({name: 'tenderitem', params: { id: this.tender.tenderId, org: this.$route.params.org }} )
                },
              }
              if (is_prequalification) {
                this.$Modal.confirm({
                  ...info,
                  okText: this.$t('Tenders.FormContract'),
                  title: this.$t('Tenders.FrameworkAgreementHasBeenCompleted'),
                  content: this.$t('Tenders.WeRecommendAddingDataApprovedParticipants'),
                })
                return //<!--framework todo  ЯКЩО НЕМАЄ ЗАТВЕРДЖЕНИХ ? -->
              }
              if (this.winners?.length) {
                this.$Modal.confirm({
                  ...info,
                  content: `
                    <div class="px-0 h6-text">
                      <div>
                        ${ this.winners.length == 1 ? this.$t('Tenders.TenderWinner') : this.$t('Tenders.TenderWinners') }
                        ${ this.winners.join(', ') }
                      </div>
                      <div class="mt-3">
                        ${ this.winners.length == 1 ? this.$t('Tenders.FormContractInSuppliers') : this.$t('Tenders.FormContractForEveryInSuppliers') }
                      </div>
                    </div>`,
                  okText: this.$t('Tenders.FormContract'),
                })
              } else {
                delete info.onOk
                delete info.onClose
                this.$Modal.info( info )
              }
            })
            .catch(error => this.$log_error(error.message))
        }
      })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
